import { proxy } from 'valtio';
import type { EmailNotificationsState } from './schema';
import { initialEmailNotificationState } from './schema';

export const emailNotificationsState: EmailNotificationsState = proxy(
  initialEmailNotificationState(),
);

export type EmailNotificationStateKeys = keyof EmailNotificationsState['fields'];
